import type { ComponentProps } from 'react';
// components
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import { templateTypesList } from 'types/template/template.types';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  triggerClassName?: string;
  contentClassName?: string;
}

const TemplateTypeCombobox = ({
  isMulti = false,
  onValueChange,
  value,
  disabled = false,
  triggerClassName,
  contentClassName,
  ...props
}: Props) => {
  return (
    <div {...props}>
      <HubertCombobox
        itemName="template type"
        isMulti={isMulti}
        items={templateTypesList}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
        triggerClassName={triggerClassName}
        contentClassName={contentClassName}
      />
    </div>
  );
};

export default TemplateTypeCombobox;
